import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Timesheet from './Timesheet';

const mapStateToProps = (state, ownProps) => {
  const isAppAdmin =
    (state.account.auth.profile.admin_appname &&
      state.account.auth.profile.admin_appname.length > 0) ||
    false;
  const isSubAdminWithMulipleApps =
    (state.account.auth.profile.admin_appnames &&
      Object.keys(state.account.auth.profile.admin_appnames).length > 1) ||
    false;
  return {
    ...ownProps,
    profile: state.account.auth.profile || {},
    isAppAdmin,
    isSubAdminWithMulipleApps,
    // Super admin = account owner (not single/multi-app sub-admin)
    isSuperAdmin: !isAppAdmin && !isSubAdminWithMulipleApps,
    timesheetEnabled: state.ecommerce.structure.timesheetEnabled,
  };
};

const mapDispatchToProps = () => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Timesheet),
);
